<template>
  <label
    class="v3-form-label"
    :class="{ required }"
    :for="effectiveFor || undefined"
    :id="labelId || undefined"
  >
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    /** Associates this label with a control (`for` / `htmlFor`). */
    htmlFor: {
      type: String,
      default: ""
    },
    /** Alias for `htmlFor` (legacy / branch compatibility). */
    labelFor: {
      type: String,
      default: ""
    },
    /** Stable id for `aria-labelledby` (e.g. with appended units). */
    labelId: {
      type: String,
      default: ""
    }
  },
  computed: {
    effectiveFor() {
      return this.htmlFor || this.labelFor || ""
    }
  }
}
</script>

<style></style>
